/**
 * personModel - the shapes and the two mappings the person page reads a
 * profile through.
 *
 * These lived in `PersonContextPane`, which is gone: the Context pane's whole
 * content is on the Profile canvas now (see `EmployeeDetail`), and the types
 * and the availability mapping outlived the component that happened to hold
 * them. Nothing here renders.
 */

import { BadgeColor } from '../../../shared/TailwindComponents/types/badgeTypes';

export interface PersonProfile {
  availability_status?: string;
  bio?: string;
  experience_years?: number;
  fixed_working_hours?: number;
  hourly_rate?: number;
  languages_spoken?: string[];
  specializations?: string[];
  professional_memberships?: string[];
  updated_at?: string;
  profile_picture?: string;
}

export interface PersonUserInfo {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
}

/**
 * Availability → badge colour.
 *
 * The page inlined this ternary twice with different fallbacks (one defaulted
 * to red, the other to gray, so "not set" read as a problem in one place and
 * as nothing in the other). Unknown is GRAY: an unset field is missing data,
 * not an unavailable person.
 */
export const availabilityColor = (status?: string): BadgeColor => {
  if (status === 'available') return 'green';
  if (status === 'on_leave') return 'yellow';
  if (status === 'unavailable') return 'red';
  return 'gray';
};

/** `on_leave` → `On leave`. Sentence case, not the SHOUTED copy it replaces. */
export const availabilityLabel = (status?: string): string =>
  status ? status.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase()) : '';
